import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import {
  ParsedAddress,
  ParsedBankAccount
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";

export const BankAccountDetailsSlice = ({
  bankAccount,
  holderName,
  address
}: {
  bankAccount?: ParsedBankAccount;
  holderName?: string;
  address?: ParsedAddress;
}) => {
  return (
    <ContentTitle title="Bank account details" contentClassName="space-y-2">
      <KeyValue label="Account name" value={bankAccount?.name.normalized} />
      <KeyValue label="Account number" value={bankAccount?.number.normalized} />
      <KeyValue label="Type" value={bankAccount?.account_type} />
      <KeyValue label="Holder" value={holderName} />
      <KeyValue
        label="Holder address line 1"
        value={address?.structured.line_1}
      />
      <KeyValue
        label="Holder address line 2"
        value={address?.structured.line_2}
      />
      <KeyValue label="Holder zip" value={address?.structured.post_code} />
      <KeyValue label="Holder city" value={address?.structured.city} />
      <KeyValue label="Holder state" value={address?.structured.state} />
    </ContentTitle>
  );
};
